const DEFAULT_HOST = 'https://sociallabs.codelabs.id'

function trim(url) {
  return String(url || '').replace(/\/$/, '')
}

/** Absolute API base for external clients (Postman, curl docs). Always includes /api/v1. */
export function resolveStudioPublicApiBase() {
  const fromEnv = trim(process.env.VUE_APP_STUDIO_API_PUBLIC_BASE)
    || trim(process.env.VUE_APP_PUBLIC_API_URL)

  let base = fromEnv
  if (!base || /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(base)) {
    base = DEFAULT_HOST
  }

  if (!/\/api\/v1$/i.test(base)) {
    if (/\/api$/i.test(base)) base = `${base}/v1`
    else base = `${base}/api/v1`
  }
  return base
}
